export default __webpack_public_path__ + "static/media/3.8f60a85a.jpg";